// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Session from "@classes/Session";

// COMPONENTS
import DefaultFields from "../../components/DefaultFields/DefaultFields";

// HELPERS
import {createClassName} from "@helpers/utils";
import * as CobHelpers from "../../Cob.helpers";
import fulfillmentCheck from "./Fullmaktsgivare.fulfillment";
import EditableField from "../../components/EditableField/EditableField";
import FieldsCollection from "../../../../components/FieldsCollection/FieldsCollection";
import Validator from "../../../../classes/Validator";


export default class Fullmaktsgivare extends React.PureComponent {
	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired,
	};

	static companyExclusive = false;
	static privateExclusive = false;
	static fields = _getFields();

	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}


	componentDidMount()
	{
		// Set navigation events
		const isFulfilled = fulfillmentCheck(this.props, this.state)
		const app = this.props.app;
		const fulfilledViewsById = {...app.fulfilledViewsById};
		if (isFulfilled)
		{
			fulfilledViewsById["Fullmaktsgivare"] = true;
		}

		this.props.actions.setAppState({
			fulfilledViewsById
		});
	}

	render() {
		const {props, state} = this;
		const {title, session, partner} = props;
		const appConfig = partner.appSpecificConfiguration;

		const classes = createClassName("Cob-CustomerInformation", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		const showAccountFields = appConfig.showAccountFields && appConfig.showAccountFields === true;

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>

					<FieldsCollection
						fieldsPerRow={session.isCompany ? 2 : 3}
						fields={[
							{
								render: (
									<EditableField
										name="customer_firstname"
										label={session.isCompany ? "Bolag" : "Förnamn"}
										value={state.fields.customer_firstname}
										valid={state.fields.customer_firstname.length > 0}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										required
									/>
								),
							},
							{
								render: (
									<EditableField
										name="customer_lastname"
										label="Efternamn"
										value={state.fields.customer_lastname}
										valid={state.fields.customer_lastname.length > 0}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										required
									/>
								),
								display: !session.isCompany,
							},
							{
								render: (
									<EditableField
										name="customer_ssn"
										label={session.isCompany ? "Organisationsnummer" : "Personnummer"}
										placeholder={session.isCompany ? "XXXXXX-YYYY" : "ÅÅÅÅÅMMDD-XXXX"}
										value={state.fields.customer_ssn}
										readOnly={true}
										valid={true}
										onChange={this._onFieldChange}
										onBlur={this._onFieldBlur}
										required
									/>
								),
							}
						]}
					/>


					{showAccountFields && (
						<EditableField
							name="account_numbers"
							label={"Depåer som fullmakten gäller för"}
							placeholder={"Nummer eller fritext"}
							value={state.fields.account_numbers}
							valid={state.fields.account_numbers ? state.fields.account_numbers.length > 0 : null}
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
						/>
					)}

					{!session.isCompany && (
						<React.Fragment>
							<p style={{margin: "20px 0 10px 0"}}>
								Det digitala avtalet kommer att skickas ut för signering till e-postadressen du anger
								nedan.
							</p>
							<input type={"hidden"} name={"customer_social_security_number"} value={state.fields.customer_ssn} />

							<FieldsCollection
								fieldsPerRow={2}
								fields={[
									{
										render: (
											<EditableField
												type="email"
												name="customer_email"
												label="E-postadress"
												value={state.fields.customer_email}
												valid={state.fields.customer_email ? Validator.validateEmail(state.fields.customer_email) : null}
												onChange={this._onFieldChange}
												onBlur={this._onFieldBlur}
												required
											/>
										),
									}
								]}
							/>
						</React.Fragment>
					)}
				</div>
			</div>
		);
	}

	// Internal methods
	_fieldValidator = (name, value) => {
		if (name === "customer_ssn") {
			return this.props.session.isCompany ?
				Validator.validateOrgNum(value, true) :
				Validator.validateSsn(value, true);
		}
		else {
			return value.length > 0;
		}
	};

	_onFieldChange = (name, value) => {
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) => {
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};
}


// PRIVATE FUNCTIONS
function _getFields() {
	return [
		"customer_firstname",
		"customer_lastname",
		"customer_ssn",
		"account_numbers",
		"customer_email",
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};

	const {session} = this.props;
	const {isCompany} = session;
	const getLookupData = (name) => session.lookupData ? session.lookupData[name] || "" : "";

	return {
		fields: {
			"is_company": isCompany,
			"customer_firstname": getLookupData(isCompany ? "companyName" : "firstName") || "",
			"customer_lastname": !isCompany ? (getLookupData("lastName") || "") : "",
			"customer_ssn": getLookupData(isCompany ? "orgNumber" : "ssn") || "",
			"account_numbers": "",
			"customer_email": "",
		},
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fullmakt/Fullmaktsgivare.js